import React, { Component } from 'react';
import { Switch, Spin, Tooltip, Modal, Button, Icon, Pagination, Avatar, notification, Empty, Radio } from 'antd';
import { UndoOutlined, CloseOutlined, UserOutlined } from '@ant-design/icons';
import { CSVLink } from "react-csv";
import moment from 'moment';
import { planned_admission, callLogSchema } from '../../schema/planned-admission';
import Select2 from '../../components/FormComponent/select2';
import Select2multiple from '../../components/FormComponent/select2/multiple';
import DateRange from '../../components/FormComponent/DateRange';
import networkList from '../../constants/networkList';
import postService from '../../services/httpService';
import RadioButtonLayer from '../../components/FormComponent/Input/radioButton';
import Inputlayer from '../../components/version2form_component/input';
import Datepicker from '../../components/version2form_component/Datepicker';
import Selectlayer from '../../components/version2form_component/select'
const { addCounsellorComments, getCounsellorCommentsByPatient, homepage } = networkList

const $ = require('jquery');

class Planned_Admission extends Component {
    showBillDetails = (ip, latest_counselled_by, latest_estimated_amt) => {
        if (ip != null && latest_counselled_by !== null && latest_estimated_amt !== null) {
            this
                .props
                .history
                .push(`/bill-details`, ip);
        } else {
            // notification.error({
            //     message: 'Failure',
            //     description: 'Oops, something went wrong... Please try again.',
            //     duration: 10,
            //     top: 20,
            //     right: 0
            // });
        }

        // alert(ip)
    }
    csvLink = React.createRef()
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            totalItemsCount: 0,
            downloadStatus: 0,
            'thead': [],
            'tbody': [],
            downloadtbody: [],
            commentModal: false,
            comments: null,
            patient_details: {},
            commentsArray: [],
            dateTo: moment().add(3, 'd').format('YYYY-MM-DD'),
            dateFrom: moment().format('YYYY-MM-DD'),
            callformSchema: [],

        };
    }


    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }

    componentDidMount() {

        let formSchema = Object.assign({}, planned_admission);
        formSchema['feilds'].map((feild, key) => {
            if (feild.name === 'doctorid') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Doctor';
            } else if (feild.name === 'departmentbyunit') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Department';
            } else if (feild.name === 'payment_type') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Payer Type';
            }
            else {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                delete formSchema['feilds'][key]['text'];
            }


        })
        let callformSchema = Object.assign({}, callLogSchema);
        callformSchema['feilds'].map((feild, key) => {
            if (feild.name === 'remarks') {
                callformSchema['feilds'][key]['value'] = 'remarks';
                callformSchema['feilds'][key]['visable'] = true;
            } else if (feild.name === 'calldata') {
                callformSchema['feilds'][key]['visable'] = true;
            } else if (feild.name === 'activity_type') {
                callformSchema['feilds'][key]['visible'] = false;
                callformSchema['feilds'][key]['value'] = 'admissions';
                callformSchema['feilds'][key]['text'] = 'Admissions';
            } else {
                callformSchema['feilds'][key]['value'] = null;
                callformSchema['feilds'][key]['valid'] = false;
                callformSchema['feilds'][key]['errors'] = [];
                callformSchema['feilds'][key]['visible'] = false;
                delete callformSchema['feilds'][key]['text'];
            }

        })
        this.setState({ activePage: 1, totalItemsCount: 0, 'formData': formSchema['feilds'], 'callformSchema': callformSchema['feilds'] }, () => {
            this.loadPage()
        });
    }

    componentWillUnmount() {
        localStorage.removeItem('activity_type');
        localStorage.removeItem('call_log_category_id');
        $('footer').css({ 'position': 'relative', top: 'unset' });
        this.setState({ formData: [] });
    }

    loadPage = () => {
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            let { activePage, doctor_id, department_name, payment_type, bill_value, nurse_station_code, ward_type } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            const { getPlannedAdmissionsWorklist } = networkList;
            let tableHead = [];
            tableHead = [
                {
                    "key": 'ip_no',
                    'label': 'In Patient Number'
                }, {
                    "key": 'patient_name',
                    'label': 'Patient Name'
                }, {
                    "key": 'patient_umr',
                    'label': 'Patient UMR'
                }, {
                    "key": 'mobile_number',
                    'label': 'Mobile Number'
                },
                {
                    "key": 'admission_date',
                    'label': 'date of admission',
                }, {
                    "key": 'department_name',
                    'label': 'department'
                },
                {
                    "key": 'doctor_name',
                    'label': 'Doctor Name'
                },
                {
                    "key": 'procedure_name',
                    'label': 'procedure'
                },
                {
                    "key": 'care_management',
                    'label': 'Care Management'
                },
                {
                    "key": 'counselled_by',
                    'label': 'Counselled By'
                },
                {
                    "key": 'estimate_type',
                    'label': 'Estimate Type'
                },
                {
                    "key": 'counselled_date',
                    'label': 'Counselled Date'
                },
                // {
                //     "key": 'sum_insured_amount',
                //     'label': 'Sum Insured Amount (Rs.)'
                // },
                // {
                //     "key": 'initial_estimated_amount',
                //     'label': 'Initial Counselled Amount (Rs.)'
                // },
                // {
                //     "key": 'initial_counsellor_name',
                //     'label': 'Initial Counselled By'
                // }, 

                // {
                //     "key": 'latest_estimated_amt',
                //     'label': 'Last Counselled Amount (Rs.)'
                // }
                // , {
                //     "key": 'latest_counsellor_name',
                //     'label': 'Last Counselled By'
                // }, 
                // {
                //     "key": 'approx_bill_amount',
                //     'label': 'Current Approx. Bill (Rs.)'
                // }, {
                //     "key": 'total_advance',
                //     'label': 'Total Advance'
                // },
                {
                    "key": 'same_day_admitted',
                    'label': 'Same Day Admission'
                },
                {
                    "key": 'payment_type',
                    'label': 'Payment Type'
                }, {
                    "key": 'privilege_name',
                    'label': 'Privilege Name'
                },
                {
                    "key": 'unit_name',
                    'label': 'Unit Name'
                },
                {
                    "key": 'e_date_of_admission',
                    'label': 'Estimated Date Of Admission'
                }
            ]
            let ward_type_value = ''
            if (ward_type) {
                if (ward_type.length > 1) {
                    ward_type_value = 'all'
                } else {
                    ward_type_value = ward_type[0]
                }
            } else {
                ward_type_value = null
            }
            this.setState((state) => ({ downloadStatus: 0, tbody: [], tableTitle: 'Planned Admission', thead: tableHead, loadding: true, filename: 'Track-Bills-Report.csv' }), () => {
                postService(getPlannedAdmissionsWorklist, 'POST', {
                    "data": {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        "search_key": this.state.search ? this.state.search : "",
                        // "counselled_by_id": null,
                        "export": 0, //1 for download excel
                        "page_no": activePage,
                        "doctor_id": doctor_id ? doctor_id : [],
                        "department_name": department_name ? department_name : [],
                        "payment_type": payment_type ? payment_type : [],
                        "from": This.state.dateFrom ? moment(this.state.dateFrom).format('YYYY-MM-DD') : '',
                        "to": This.state.dateTo ? moment(this.state.dateTo).format('YYYY-MM-DD') : '',
                        // "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                        // "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                        // "bill_value": bill_value ? bill_value : [],
                        // "nurse_station_code": nurse_station_code ? nurse_station_code : [],
                        // "ward_type": ward_type_value

                    }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        // res.data.admissions_data.map((data, key) => {
                        //     Object.keys(data).map((dataKey) => {
                        //         if (dataKey === 'e_date_of_admission') {
                        //             res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                        //         }
                        //         if (dataKey === 'e_date_of_admission') {
                        //             res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                        //         }

                        //     })
                        // })
                        this.setState((state) => ({ totalItemsCount: res.total_items, tbody: res.data.admissions_data, loadding: false }));
                        // enable downloadbtn after 2sec
                        setTimeout(function () {
                            This.setState((state) => ({ downloadStatus: 1 }))
                        }, 2000);
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
            //     setTimeout(function () {
            //     This.setState((state) => ({downloadStatus:0,tableTitle: 'Track Bills', thead: tableHead, loadding: true, filename: 'Track-Bills-Report.csv' }), () => {
            //         postService(getBillTrackingReport, 'POST', {
            //             "data": {
            //                 "unit_id":userData ? userData['unitid'] ? userData['unitid'] :null :null,
            //                 "search_key": This.state.search ? This.state.search : "",
            //                 "counselled_by_id": null,
            //                 "export": 1, //1 for download excel
            //                 "page_no": 0
            //             }
            //         }).then(res => {
            //             console.log('tat report:', res);
            //             // console.log('data res:', data)
            //             if (res.status) {
            //                 res.data.map((data, key) => {
            //                     Object.keys(data).map((dataKey) => {
            //                         if (dataKey === 'admission_date') {
            //                             res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
            //                         }
            //                         if (dataKey === 'latest_counselled_date') {
            //                             res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : 'NA'
            //                         }
            //                         else {
            //                             res.data[key][dataKey] = res.data[key][dataKey] ? res.data[key][dataKey] : 'NA'
            //                         }

            //                     })
            //                 })
            //                 This.setState((state) => ({ downloadtbody: res.data, loadding: false,downloadStatus:1 }));
            //             } else {
            //                 if (res === 401) {

            //                 } else {
            //                     Modal.error({
            //                         title: 'Failure',
            //                         content: "Oops! something went wrong... Please try again.",
            //                     });
            //                 }
            //             }
            //         });
            //     });
            // },3000);
        } catch (error) {
            console.log(error);
        }
    }

    handleChange(ele) {
        let { callformSchema } = this.state
        if (ele.name === 'category') {
            localStorage.setItem('call_log_category_id', ele.value);
        }
        callformSchema.map((item, key) => {
            if (ele.name === 'reason') {
                if (item.name === 'call_log_back_date') {
                    callformSchema[key]['visible'] = ele.call_log_back_date_field ? true : false;
                }
                if (item.name === 'call_log_estimated_admission_date') {
                    callformSchema[key]['visible'] = ele.call_log_eda_field ? true : false;
                }
                if (item.name === 'call_log_ip_number') {
                    callformSchema[key]['visible'] = ele.call_log_ip_number_field ? true : false;
                }
                if (item.name === 'call_log_date_of_surgery') {
                    callformSchema[key]['visible'] = ele.call_log_surgery_date_field ? true : false;
                }
            }
            if(ele.name==="call_log_estimated_admission_date"){
                if(item.name==='call_log_date_of_surgery'){
                    callformSchema[key]['EDA']=ele.value?ele.value:null
                }
            }
            if(ele.name==='category'){
                if(item.name==='reason'){
                    callformSchema[key]['value']=null;
                    callformSchema[key]['text']=null;
                    callformSchema[key]['disable']=false;
                }
                if (item.name === 'call_log_back_date') {
                    callformSchema[key]['value']=null;
                    callformSchema[key]['text']=null;
                    callformSchema[key]['visible']=false;
                }
                if (item.name === 'call_log_estimated_admission_date') {
                    callformSchema[key]['value']=null;
                    callformSchema[key]['text']=null;
                    callformSchema[key]['visible']=false;
                }
                if (item.name === 'call_log_ip_number') {
                    callformSchema[key]['value']=null;
                    callformSchema[key]['text']=null;
                    callformSchema[key]['visible']=false;
                }
                if (item.name === 'call_log_date_of_surgery') {
                    callformSchema[key]['value']=null;
                    callformSchema[key]['text']=null;
                    callformSchema[key]['visible']=false;
                    callformSchema[key]['EDA']=null;
                }
            
                
            }
        })
        this.setState({ 'callformSchema': callformSchema })


    }

    submit() {
        var formFeilds = this.state.formData;
        let { search } = this.state
        this.setState(({ doctor_id: formFeilds[0].value, department_name: formFeilds[1].value, payment_type: formFeilds[2].value, search: '', activePage: 1, }), () => {
            this.inputRef.value = null;
            this.loadPage()
        })
    }
    searchChange(e) {
        console.log(e.target.value);
        let value = e.target.value
        this.setState((state) => ({ 'search': value }), () => {

        });
    }
    searchClick() {
        this.setState((state) => ({
            activePage: 1,
            tbody: [],
            totalItemsCount: 0,
            doctor_id: [],
            department_name: [],
            payment_type: [],
            bill_value: [],
            nurse_station_code: [],
            ward_type: []
        }), () => {
            this.loadPage();
            var formFeilds = this.state.formData;
            formFeilds.map((feild, key) => {
                if (feild.name === 'doctorid') {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Doctor';
                } else if (feild.name === 'departmentbyunit') {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Department';
                } else if (feild.name === 'payment_type') {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Payer Type';
                } else if (feild.name === 'bill_value') {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Bill Value';
                } else if (feild.name === 'nursestationbyunit') {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Nurse Station';
                } else if (feild.name === 'ward_type') {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Ward Type';
                } else {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    delete formFeilds[key]['text'];
                }
            })
            this.setState({ formData: formFeilds })
        })
    }

    handlePageChange(page) {
        console.log(page);
        this.setState((state) => ({
            activePage: page,
            tbody: []
        }), () => {
            this.loadPage();
        })
    }
    downloadFile = () => {
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            let { activePage, doctor_id, department_name, payment_type, bill_value, nurse_station_code, ward_type } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            const { getPlannedAdmissionsWorklist } = networkList;
            let tableHead = [];
            tableHead = [
                {
                    "key": 'ip_no',
                    'label': 'In Patient Number'
                }, {
                    "key": 'patient_name',
                    'label': 'Patient Name'
                }, {
                    "key": 'patient_umr',
                    'label': 'Patient UMR'
                },
                {
                    "key": 'mobile_number',
                    'label': 'Mobile Number'
                }, {
                    "key": 'admission_date',
                    'label': 'date of admission',
                }, {
                    "key": 'department_name',
                    'label': 'department'
                },
                {
                    "key": 'doctor_name',
                    'label': 'Doctor Name'
                },
                {
                    "key": 'procedure_name',
                    'label': 'procedure'
                },
                {
                    "key": 'care_management',
                    'label': 'Care Management'
                },
                {
                    "key": 'counselled_by',
                    'label': 'Counselled By'
                },
                {
                    "key": 'estimate_type',
                    'label': 'Estimate Type'
                },
                {
                    "key": 'counselled_date',
                    'label': 'Counselled Date'
                },
                // {
                //     "key": 'sum_insured_amount',
                //     'label': 'Sum Insured Amount (Rs.)'
                // },
                // {
                //     "key": 'initial_estimated_amount',
                //     'label': 'Initial Counselled Amount (Rs.)'
                // },
                // {
                //     "key": 'initial_counsellor_name',
                //     'label': 'Initial Counselled By'
                // }, 

                // {
                //     "key": 'latest_estimated_amt',
                //     'label': 'Last Counselled Amount (Rs.)'
                // }
                // , {
                //     "key": 'latest_counsellor_name',
                //     'label': 'Last Counselled By'
                // }, 
                // {
                //     "key": 'approx_bill_amount',
                //     'label': 'Current Approx. Bill (Rs.)'
                // }, {
                //     "key": 'total_advance',
                //     'label': 'Total Advance'
                // },
                {
                    "key": 'same_day_admitted',
                    'label': 'Same Day Admission'
                },
                {
                    "key": 'payment_type',
                    'label': 'Payment Type'
                }, {
                    "key": 'privilege_name',
                    'label': 'Privilege Name'
                },
                {
                    "key": 'unit_name',
                    'label': 'Unit Name'
                },
                {
                    "key": 'e_date_of_admission',
                    'label': 'Estimated Date Of Admission'
                }
            ]
            let ward_type_value = ''
            if (ward_type) {
                if (ward_type.length > 1) {
                    ward_type_value = 'all'
                } else {
                    ward_type_value = ward_type[0]
                }
            } else {
                ward_type_value = null
            }
            This.setState((state) => ({ downloadStatus: 0, thead: tableHead, loadding: true, filename: 'Planned-Admission.csv' }), () => {
                postService(getPlannedAdmissionsWorklist, 'POST', {
                    "data": {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        "search_key": this.state.search ? this.state.search : "",
                        // "counselled_by_id": null,
                        "export": 1, //1 for download excel
                        "page_no": activePage,
                        "doctor_id": doctor_id ? doctor_id : [],
                        "department_name": department_name ? department_name : [],
                        "payment_type": payment_type ? payment_type : [],
                        "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                        "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                        // "bill_value": bill_value ? bill_value : [],
                        // "nurse_station_code": nurse_station_code ? nurse_station_code : [],
                        // "ward_type": ward_type_value

                    }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        res.data.admissions_data.map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                // if (dataKey === 'admission_date') {
                                //     res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                // }
                                // if (dataKey === 'latest_counselled_date') {
                                //     res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : 'NA'
                                // }
                                // else {
                                res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? res.data.admissions_data[key][dataKey] : 'NA'
                                // }

                            })
                        })
                        This.setState((state) => ({ downloadtbody: res.data.admissions_data, loadding: false, downloadStatus: 1 }));
                        this.csvLink.current.link.click();
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }
    clearFilter = () => {
        this.setState(() => ({ doctor_id: '', department_name: '', payment_type: '', bill_value: '', nurse_station_code: '', ward_type: '', search: '', activePage: 1, totalItemsCount: 0 }),
            () => {
                this.inputRef.value = null;
                var formFeilds = this.state.formData;
                formFeilds.map((feild, key) => {
                    if (feild.name === 'doctorid') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Doctor';
                    } else if (feild.name === 'departmentbyunit') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Department';
                    } else if (feild.name === 'payment_type') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Payer Type';
                    } else {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        delete formFeilds[key]['text'];
                    }
                })
                this.setState({ formData: formFeilds })
                this.loadPage();
            })

    }

    commentsModal = (data) => {
        let This = this
        let user_data
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        try {
            This.setState((state) => ({ commentModal: true, patient_details: data, loadding: true }), () => {
                postService(getCounsellorCommentsByPatient, 'POST', {
                    "data": {
                        "unit_id": user_data['unitid'] ? user_data['unitid'] : null,
                        "umr_no": data.patient_umr ? data.patient_umr : null
                    }
                }).then(res => {
                    console.log('comments:', res);
                    if (res.status) {
                        This.setState((state) => ({ 'loadding': false, 'commentsArray': res['data'] }));
                    } else {
                        This.setState((state) => ({ 'loadding': false, 'commentsArray': [] }));
                        Modal.error({
                            title: 'Failure',
                            content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                            zIndex: 1022
                        });
                    }
                });
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
                zIndex: 1022
            });
        }
    }

    comments(event) {
        let value = event.target.value;
        this.setState((state) => ({ 'comments': value ? value : null }));
    }

    submitCommint = () => {
        let { comments, patient_details, callformSchema } = this.state
        let This = this
        let user_data
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        let errors = this.validateModalFeilds(callformSchema);
        let call_log, activity_type, call_log_eda, call_log_category, call_log_reason, call_back_date,
            call_log_surgery_date, call_log_ip_no;
        callformSchema.map((item, key) => {
            if (item.name === 'calldata') {
                call_log = item.value;
            }
            if (item.name === 'activity_type') {
                activity_type = item.value;
            }
            if (item.name === 'category') {
                call_log_category = item.value;
            }
            if (item.name === 'reason') {
                call_log_reason = item.value;
            }
            if (item.name === 'call_log_estimated_admission_date') {
                call_log_eda = item.value;
            }
            if (item.name === 'call_log_back_date') {
                call_back_date = item.value;
            }
            if (item.name === 'call_log_date_of_surgery') {
                call_log_surgery_date = item.value;
            }
            if (item.name === 'call_log_ip_number') {
                call_log_ip_no = item.value;
            }

        })
        let payload = {
            "umr_no": patient_details.patient_umr ? patient_details.patient_umr : null,
            "unit_id": user_data['unitid'] ? user_data['unitid'] : null,
            "comment": comments?comments:null,
            "comment_from": activity_type ? activity_type : null,
            "call_log": call_log ? true : false,
            "call_log_eda": call_log_eda ? call_log_eda : null,
            "call_back_date": call_back_date ? call_back_date : null,
            "call_log_surgery_date": call_log_surgery_date ? call_log_surgery_date : null,
            "call_log_category": call_log_category ? call_log_category.toString() : null,
            "call_log_ip_no": call_log_ip_no ? call_log_ip_no.toString() : null,
            "call_log_reason": call_log_reason ? call_log_reason.toString() : null,
            "admission_id":patient_details.admission_id?patient_details.admission_id:null,
            "doctor_id":patient_details.doctor_id?patient_details.doctor_id:null,
            "is_iccu":patient_details.is_iccu?patient_details.is_iccu:null,
            "ip_no": patient_details.ip_no ? patient_details.ip_no : null,
        }
        if (call_log!==null && !errors.includes(false)) {
            try {
                This.setState((state) => ({ loadding: true }), () => {
                    postService(addCounsellorComments, 'POST', {
                        "data": payload
                    }).then(res => {
                        console.log('comments:', res);
                        if (res.status) {
                            Modal.success({
                                title: 'Success',
                                content: res.message ? res.message : "Success",
                                zIndex: 1022
                            });
                            callformSchema.map((feild, key) => {
                                if (feild.name === 'remarks') {
                                    callformSchema[key]['value'] = 'remarks';
                                    callformSchema[key]['visible'] = true;
                                } else if (feild.name === 'calldata') {
                                    callformSchema[key]['visible'] = true;
                                    callformSchema[key]['value'] = null;
                                } else if (feild.name === 'activity_type') {
                                    callformSchema[key]['visible'] = false;
                                    callformSchema[key]['value'] = 'admissions';
                                    callformSchema[key]['text'] = 'Admissions';
                                } else {
                                    callformSchema[key]['value'] = null;
                                    callformSchema[key]['valid'] = false;
                                    callformSchema[key]['errors'] = [];
                                    callformSchema[key]['visible'] = false;
                                    delete callformSchema[key]['text'];
                                }
                            })
                            This.loadPage();
                            localStorage.removeItem('call_log_category_id');
                            This.setState((state) => ({ 'loadding': false, comments: null, 'callformSchema': callformSchema }));
                            This.commentsModal(patient_details)
                        } else {
                            This.setState((state) => ({ 'loadding': false }));
                            Modal.error({
                                title: 'Failure',
                                content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                                zIndex: 1022
                            });
                        }
                    });
                });
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Failure',
                    content: "Oops, something went wrong... Please try again.",
                });
            }
        }

        if(call_log===null ){
            if(comments && comments.length > 12){
                try {
                    This.setState((state) => ({ loadding: true }), () => {
                        postService(addCounsellorComments, 'POST', {
                            "data": payload
                        }).then(res => {
                            console.log('comments:', res);
                            if (res.status) {
                                Modal.success({
                                    title: 'Success',
                                    content: res.message ? res.message : "Success",
                                    zIndex: 1022
                                });
                                callformSchema.map((feild, key) => {
                                    if (feild.name === 'remarks') {
                                        callformSchema[key]['value'] = 'remarks';
                                        callformSchema[key]['visible'] = true;
                                    } else if (feild.name === 'calldata') {
                                        callformSchema[key]['visible'] = true;
                                        callformSchema[key]['value'] = null;
                                    } else if (feild.name === 'activity_type') {
                                        callformSchema[key]['visible'] = false;
                                        callformSchema[key]['value'] = 'admissions';
                                        callformSchema[key]['text'] = 'Admissions';
                                    } else {
                                        callformSchema[key]['value'] = null;
                                        callformSchema[key]['valid'] = false;
                                        callformSchema[key]['errors'] = [];
                                        callformSchema[key]['visible'] = false;
                                        delete callformSchema[key]['text'];
                                    }
                                })
                                This.loadPage();
                                This.setState((state) => ({ 'loadding': false, comments: null, 'callformSchema': callformSchema }));
                                This.commentsModal(patient_details)
                                localStorage.removeItem('call_log_category_id');
                            } else {
                                This.setState((state) => ({ 'loadding': false }));
                                Modal.error({
                                    title: 'Failure',
                                    content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                                    zIndex: 1022
                                });
                            }
                        });
                    });
                } catch (error) {
                    console.log(error);
                    this.setState((state) => ({ 'loadding': false }));
                    Modal.error({
                        title: 'Failure',
                        content: "Oops, something went wrong... Please try again.",
                    });
                } 
               }else{
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Failure',
                    content: 'Please enter comment briefly.',
                    zIndex: 1022
                }) 
            }
        }
            
        
    }
    dateRange = () => {
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
        }), () => {
            this.loadPage(true);
        })
    }

    onChange(type, evet) {
        console.log(evet, type);
        let { callformSchema } = this.state
        callformSchema.map((item, key) => {
            if (type.name === 'remarks') {
                if (item.name === 'remarks') {
                    callformSchema[key]['value'] = 'remarks';
                }
                if (item.name === 'calldata') {
                    callformSchema[key]['value'] = null;
                } else {
                    if (item.name === 'remarks' || item.name === 'calldata') {
                        callformSchema[key]['visible'] = true;
                    } else {
                        callformSchema[key]['visible'] = false;
                    }
                }
                
            }
            if (type.name === 'calldata') {
                localStorage.setItem('activity_type', "admission");
                if (item.name === 'calldata') {
                    callformSchema[key]['value'] = 'calldata';
                }
                if (item.name === 'remarks') {
                    callformSchema[key]['value'] = null;
                }
                if (item.name === 'activity_type') {
                    callformSchema[key]['visible'] = true;
                }
                if (item.name === 'category') {
                    callformSchema[key]['visible'] = true;
                    callformSchema[key]['value'] = null;
                    callformSchema[key]['text'] = null;
                }
                if (item.name === 'reason') {
                    callformSchema[key]['visible'] = true;
                    callformSchema[key]['value'] = null;
                    callformSchema[key]['text'] = null;
                    callformSchema[key]['disable']=true;
                }
            }
        })
        localStorage.removeItem('call_log_category_id');
        this.setState({ 'callformSchema': callformSchema })
    }
    historyModelClose() {
        let { callformSchema } = this.state
        callformSchema.map((feild, key) => {
            if (feild.name === 'remarks') {
                callformSchema[key]['value'] = 'remarks';
                callformSchema[key]['visible'] = true;
            } else if (feild.name === 'calldata') {
                callformSchema[key]['visible'] = true;
                callformSchema[key]['value'] = null;
            } else if (feild.name === 'activity_type') {
                callformSchema[key]['visible'] = false;
                callformSchema[key]['value'] = 'admissions';
                callformSchema[key]['text'] = 'Admissions';
            } else {
                callformSchema[key]['value'] = null;
                callformSchema[key]['valid'] = false;
                callformSchema[key]['errors'] = [];
                callformSchema[key]['visible'] = false;
                delete callformSchema[key]['text'];
            }
        })
        this.loadPage();
        localStorage.removeItem('call_log_category_id');
        this.setState({ commentModal: false, comments: null, callformSchema: callformSchema })
    }
    validateModalFeilds(formFeilds) {
        let errors = [];
        let role_id = null;
        formFeilds.map((feild, key) => {
            if ((feild['element'] === 'input' || feild['element'] === "select2" || feild['element'] === 'Select2multiple' || feild['element'] === 'datepicker')) {
                formFeilds[key]['errors'] = [];
                if (!feild.disable && feild.visible) {
                    feild
                        .rules
                        .map((rule, rkey) => {
                            if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined)) {

                                formFeilds[key]['errors'].push({ 'message': rule.message });
                                errors.push(false);
                            }
                            else {
                                console.log('no', feild['name'], feild['value'])
                                formFeilds[key]['errors'] = [];
                                errors.push(true);
                            }
                        })

                }
            }
        })

        this.setState((state) => ({ callformSchema: formFeilds }));
        return errors;
    }
    navigateTo(data) {
        window.open(`${homepage}/counselling/view-finanical-counselling?pid=${data.payment_type_id}&cid=${data.counselling_id}&fid=${data.form_type}`, '_blank', 'noopener,noreferrer');
        // this.props.history.push(`/counselling/view-finanical-counselling?pid=${payment_type_id}&cid=${counselling_id}&fid=${form_type}`);
        // this.props.history.push('/counselling/basic-details?cd=1&rid='+counselling_id);
    }

    render() {
        let { tableTitle, thead, activePage, tbody, downloadtbody, filename, formData, totalItemsCount, downloadStatus, commentModal, comments, patient_details, commentsArray, loadding, callformSchema } = this.state;
        console.log(callformSchema);
        return (
            <div>
                <div className="clearfix mx-5">
                    <div className="float-left pt-2">
                        {tableTitle}
                    </div>
                    {
                        downloadStatus && tbody != ''
                            ?
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                <button className="btn btn-success text-capitalize" onClick={() => { this.downloadFile() }}><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download Report</span></button>
                                <CSVLink data={downloadtbody} headers={thead} filename={filename} className="hidden" ref={this.csvLink} />
                                <button className="btn btn-light text-capitalize py-1 mr-3" onClick={() => { this.clearFilter() }}><UndoOutlined className="align-middle pr-2" /><span> Clear</span></button>
                                <button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit() }}><span>Submit</span></button>
                            </div>
                            :
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                <Button className="btn btn-success-disabled text-capitalize" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download Report</span></Button>
                                <button className="btn btn-light text-capitalize py-1 mr-3 " onClick={() => { this.clearFilter() }}><UndoOutlined type="reload" className="align-middle pr-2" /><span> Clear</span></button>
                                <Button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit() }}><span>Submit</span></Button>
                            </div>
                    }
                </div>

                <Spin spinning={loadding}>
                    <div className="card ml-5 mr-5 mb-5 card-table">
                        <div className="card-header bg8">
                            <div className="clearfix">
                                <div className="row">
                                    {(formData !== undefined) && <React.Fragment>

                                        {formData
                                            .map((feild, key) => {

                                                if (feild.element === 'input') {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                className={`${feild.className
                                                                    ? feild.className
                                                                    : 'col '} ${feild.name}`}
                                                                key={key}>
                                                                <div className="input-group" key={key}>
                                                                    {/* <input type="text" id="myInput" className="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR or IP" /> */}
                                                                    <div
                                                                        className='w-100'
                                                                        key={key}>
                                                                        <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR or IP" onBlur={this.searchChange.bind(this)} ref={(inputRef => (this.inputRef = inputRef))} />
                                                                        <div class="input-group-append" style={{ position: 'absolute', right: 0, height: '32px', top: 0 }}>
                                                                            <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="input-group-append" style={{position: 'absolute', right: 0, height: '32px'}}>                                                                    
                                                                    <button className="btn btn-primary btn-sm" onClick={this.search}><img src="/assets/images/icons/search.png" /></button>
                                                                </div> */}
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                                if (feild.element === 'select2') {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                className={`${feild.className
                                                                    ? feild.className
                                                                    : 'col '} ${feild.name}`}
                                                                key={key}>
                                                                {/* <p className="data-label text-white w-25 mb-1 pt-1 text-right pr-2">{feild.text2}</p> */}
                                                                <Select2
                                                                    Queuedata={formData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={this
                                                                        .handleChange
                                                                        .bind(this)}
                                                                /> {feild
                                                                    .errors
                                                                    .map((error, eKey) => {
                                                                        return (
                                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                        );
                                                                    })}
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                                if (feild.element === 'select2multiple' && feild.visible) {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                className={`${feild.className
                                                                    ? feild.className
                                                                    : 'col '} ${feild.name}`}
                                                                key={key}>
                                                                <Select2multiple
                                                                    Queuedata={formData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={this
                                                                        .handleChange
                                                                        .bind(this, feild)}
                                                                /> {feild
                                                                    .errors
                                                                    .map((error, eKey) => {
                                                                        return (
                                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                        );
                                                                    })}
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                                if (feild.element === 'daterange') {
                                                    return (
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} ${feild.name}`}
                                                            key={key}>
                                                            {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}

                                                            <DateRange
                                                                Queuedata={formData}
                                                                selectdata={feild}
                                                                {...this.props}
                                                                {...this.state}
                                                                onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({ dateFrom: e.value[0], dateTo: e.value[1] }) }}
                                                            />
                                                            <div class="input-group-append">
                                                                <button class="btn btn-primary btn-sm ml-1" onClick={this.dateRange}>Go</button>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })}

                                    </React.Fragment>}
                                </div>
                            </div>
                        </div>
                        <div className="financial-table table-responsive sticky-header" id="table">
                            <table className="table table-hover table-bordered mb-0 track-bills bg-white">
                                <thead>
                                    <tr>
                                        <td className="text-capitalize align-middle">s.no.</td>
                                        {thead.map((head, key) => {
                                            return (<td className="text-capitalize align-middle" key={key}>{head['label']}</td>)
                                        })}
                                    </tr>
                                </thead>
                                {
                                    tbody && tbody.length > 0
                                        ?
                                        <tbody>
                                            {tbody.map((body, key) => {
                                              
                                                return (<tr key={key}
                                                // style={(body.ip_no != null && body.latest_counselled_by !== null && body.latest_estimated_amt !== null) ? { 'cursor': 'pointer', 'backgroundColor': '#ffeeba' } : { 'cursor': 'default' }}
                                                >
                                                    <td
                                                    // onClick={this.showBillDetails.bind(this, body.ip_no, body.latest_counselled_by, body.latest_estimated_amt)}
                                                    >{(key + 1) + (activePage > 1 ? 20 * (activePage > 2 ? (activePage - 1) : 1) : 0)}</td>
                                                    {thead.map((head, Hkey) => {
                                                        // if (head['key'] === 'admission_date') {
                                                        //     return (<td  key={Hkey} >{body['admission_date']?moment(body['admission_date']).format('DD-MM-YYYY HH:mm'):'NA'}</td>)
                                                        // }

                                                        if (head['key'] === 'patient_umr') {
                                                            return (<td key={Hkey} className="text-capitalize"
                                                            // style={(body.patient_umr != null && body.latest_counselled_by !== null && body.latest_estimated_amt !== null) ? { 'cursor': 'pointer', 'backgroundColor': '#ffeeba' } : {}}
                                                            ><Tooltip title="Comments History"><p style={{ 'cursor': 'pointer', 'color': 'blue' }} onClick={() => { this.commentsModal(body) }}>{body[head['key']] ? body[head['key']] : 'NA'}</p></Tooltip>
                                                            {/* <img src="/assets/images/icons/view.png" alt="view" title="view" onClick={() => { this.navigateTo(body) }}/> */}
                                                            </td>);

                                                        }
                                                        if (head['key'] === 'patient_name') {
                                                            return (<td key={Hkey} className="text-capitalize"
                                                            // style={(body.patient_umr != null && body.latest_counselled_by !== null && body.latest_estimated_amt !== null) ? { 'cursor': 'pointer', 'backgroundColor': '#ffeeba' } : {}}
                                                            ><Tooltip title="View Financial Counselling"><p style={{ 'cursor': 'pointer', 'color': 'blue' }} onClick={() => { this.navigateTo(body) }}>{body[head['key']] ? body[head['key']] : 'NA'}</p></Tooltip></td>);

                                                        }
                                                        if (head['key'] === 'e_date_of_admission') {
                                                            return (
                                                                <td key={Hkey} className="text-capitalize">
                                                                    {body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY'): body[head['key']] || 'NA'}
                                                                </td>
                                                            )
                                                        }
                                                        if (head['key'] === 'counselled_date') {
                                                            return (
                                                                <td key={Hkey} className="text-capitalize">
                                                                    {body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm'): body[head['key']] || 'NA'}
                                                                </td>
                                                            )
                                                        }
                                                        return (
                                                            <td key={Hkey} className="text-capitalize">
                                                              {head['key'] === 'counselled_date' && body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm') : body[head['key']] || 'NA'}
                                                            </td>
                                                          );
                                                          
        
                                                        // console.log(body[head['key']] ? body[head['key']] : 'NA');
                                                        // return (<td key={Hkey} className="text-capitalize"
                                                        // // onClick={this.showBillDetails.bind(this, body.ip_no, body.latest_counselled_by, body.latest_estimated_amt)}
                                                        // >{body[head['key']] ? body[head['key']] : 'NA'}</td>);


                                                        // return (
                                                        //     <td className="text-capitalize">{(body[head['key']] !== null) ? body[head['key']] : 'NA'}</td>
                                                        // )

                                                    })
                                                    }
                                                </tr>)
                                            })}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                    <p className="no-data mb-0">No Data</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                }
                            </table>
                        </div>

                    </div>
                    <div className="row justify-content-center align-item-center mx-0">
                        <div className="col pagenation-col mb-3">
                            {/* <Pagination

                                activePage={this.state.activePage}
                                itemsCountPerPage={20}
                                totalItemsCount={totalItemsCount}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange.bind(this)}
                            /> */}
                            <Pagination current={this.state.activePage} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={20} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />

                        </div>
                    </div>
                    <Modal
                        title=''
                        centered
                        footer={null}
                        width='80%'
                        zIndex='1021'
                        closable={false}
                        maskClosable={false}
                        visible={commentModal}>
                        <Spin spinning={loadding}>
                            <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => { this.historyModelClose() }} /></Tooltip>
                            <h4 className="text-center pb-4">Comments History</h4>
                            <div className="row pb-3">
                                <div className="col-8 my-auto">
                                    <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_details.patient_name ? patient_details.patient_name : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="UMR Number">{patient_details.patient_umr ? patient_details.patient_umr : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="IP Number">{patient_details.ip_no ? patient_details.ip_no : '--'}</Tooltip></h6>
                                </div>
                                <div className="col-4 my-auto">
                                    <div className="row">
                                        {callformSchema && callformSchema.map((feild, key) => {
                                            if (feild.visible && feild.element === 'radio') {
                                                return (
                                                    <div class={feild.name === 'remarks' ? "col-7 fontSize text-right p-0" : "col-5 fontSize text-right pl-0"}>
                                                        <Tooltip title={feild.name === 'remarks' ? "Click Remarks" : "Click Call Log"}><Radio.Button className='btn px-2 mx-1' onChange={this.onChange.bind(this, feild)}
                                                            checked={
                                                                feild.value ? true : false}
                                                        >{feild.name === 'remarks' ? <i class="fa fa-file-text pr-1" aria-hidden="true"></i> : <i class="fa fa-phone pr-1" aria-hidden="true"></i>}{feild.title}</Radio.Button></Tooltip>
                                                        {feild.errors.map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger" style={{ bottom: '-15px' }}>{error.message}</small>
                                                            );
                                                        })}
                                                    </div>
                                                )
                                            }
                                        })}
                                    </div>

                                </div>

                            </div>
                           
                            <div className='bg-white white-board'>
                                <div className="row w-100 mx-auto labelColorChange">
                                    {callformSchema && callformSchema.map((feild, key) => {
                                        if (feild.visible && feild.element === 'select2') {
                                            return (
                                                <div class="col-4 mt-3">
                                                    <label className="data-label w-100">{feild.title}</label>
                                                    <Select2
                                                        selectdata={feild}
                                                        changedObj={this.state.changedObj}
                                                        {...this.props}
                                                        {...this.state}
                                                        Queuedata={this.state.formData}
                                                        onselectChanges={this
                                                            .handleChange
                                                            .bind(this)} />
                                                    {feild
                                                        .errors
                                                        .map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                            );
                                                        })}

                                                </div>
                                            )
                                        }
                                    })}
                                </div>
                                <div className="row w-100 mx-auto labelColorChange ">
                                    {callformSchema && callformSchema
                                        .map((feild, key) => {
                                            if (feild.visible && feild.element === 'input') {
                                                return <Inputlayer
                                                    {...this.props} {...this.state}
                                                    feild_data={feild} key={key}
                                                    inputChange={this.handleChange.bind(this)} />
                                            }

                                            if (feild.visible && feild.element === 'datepicker') {
                                                return <Datepicker {...this.props}
                                                    {...this.state}
                                                    feild_data={feild}
                                                    key={key}
                                                    inputChange={this.handleChange.bind(this)} />
                                            }
                                            if (feild.visible && feild.element === 'text') {
                                                return (<div className="col-xl-12 col-lg-12 col-sm-12 d-flex">
                                                    <p className="data-label pr-1">{feild.title}</p>
                                                </div>)

                                            }
                                        })}

                                    <div class="col-12  mt-3 mb-3">
                                        <textarea placeholder="Enter your comments..." autoFocus='true' className="textarea" style={{ height: '80px' }} value={comments ? comments : ''} onChange={(event) => this.comments(event)}></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center mt-3 mb-4">
                                <button className="btn btn-success" onClick={() => { this.submitCommint() }}>Submit</button>
                            </div>
                            <div class="row pt-3 w-100 mx-auto bg-white white-board">
                            <h5 className='pl-3 pb-3 pt-3'>History</h5>
                                {commentsArray.length>0&&commentsArray.map((data, key) => {
                                    return <div className="col-12 pb-1">
                                        <div class={commentsArray.length-1!==key?"media hr-call-log":"media"}>
                                            {/* <img src="https://www.w3schools.com/bootstrap4/img_avatar3.png" style={{ 'width': '60px' }} /> */}
                                            <div class="align-self-start mr-3">
                                                <Avatar size={50} icon={<UserOutlined />} className="align-middle" /><br></br>
                                            </div>
                                            <div class="media-body">
                                                <div className='row'>
                                                    <div className='col-12'>
                                                    <h6>
                                                    <Tooltip title="Created By"><small className="text-capitalize">{data.created_by}</small></Tooltip><span className="mx-3">|</span> 
                                                    <Tooltip title='Created On'><small>{moment(data.created_at).format('DD-MM-YYYY hh:mm A')}</small></Tooltip> <span className="mx-3">|</span> 
                                                    <Tooltip title="Comment From"><small className="text-capitalize">{data.remarks_from}</small></Tooltip>
                                                    </h6>  
                                                    </div>
                                                    <div className='col-8'>
                                                <h6 className='mb-1'>
                                                {data.category_name!=="null"&&data.category_name!==null?<Tooltip title="Category"><small className="text-capitalize "> {data.category_name}</small></Tooltip>:''}
                                                {data.call_log_reason!=="null" && data.call_log_reason!==null?<span className="mx-3">|</span>:''}
                                                {data.call_log_reason!=="null"&&data.call_log_reason!==null?<Tooltip title="Reason"><small className="text-capitalize "> {data.call_log_reason}</small></Tooltip>:''}
                                                {data.call_log_eda!=="null" && data.call_log_eda!==null?<span className="mx-3">|</span>:''}
                                                {data.call_log_eda!=="null"&&data.call_log_eda!==null?<Tooltip title="Estimated Date Of Admission"><small className="text-capitalize ">EDA: {moment(data.call_log_eda).format('DD-MM-YYYY')}</small></Tooltip>:''}
                                                {data.call_log_surgery_date!=="null" && data.call_log_surgery_date!==null ?<span className="mx-3">|</span>:''}
                                                {data.call_log_surgery_date!=="null" && data.call_log_surgery_date!==null ?<Tooltip title="Date Of Surgery"><small className="text-capitalize ">DOS: {moment(data.call_log_surgery_date).format('DD-MM-YYYY')}</small></Tooltip>:''}
                                                {data.call_back_date!=="null" && data.call_back_date!==null?<span className="mx-3">|</span>:''}
                                                {data.call_back_date!=="null"&&data.call_back_date!==null?<Tooltip title="Call Back Date"><small className="text-capitalize ">CBD: {moment(data.call_back_date).format('DD-MM-YYYY')}</small></Tooltip>:''}
                                                </h6>
                                                </div>
                                                <div className='col-12'>
                                                <p>{data.remarks}</p>
                                                </div>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                })}
                                {commentsArray && commentsArray.length == 0 && <Empty className="mx-auto" description={<span>No history is available for this patient.</span>} />}
                            </div>
                        </Spin>
                    </Modal>
                </Spin>
            </div>
        )
    }
}

export default Planned_Admission;